var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("header", { staticClass: "menu-header" }, [
    _c("div", { staticClass: "menu-header__wrapper" }, [
      _c("div", { staticClass: "main-logo" }, [
        _c(
          "a",
          [
            _c(_vm.iconComponent("logo-" + _vm.themeName), { tag: "component" })
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "menu-header__content" }, [
        _c("h1", {
          staticClass: "menu-header__title",
          domProps: { innerHTML: _vm._s(_vm.title) }
        }),
        _vm._v(" "),
        _c("h2", {
          staticClass: "menu-header__subtitle",
          domProps: { innerHTML: _vm._s(_vm.subtitle) }
        })
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }